export const MAX_DECIMAL_DIGITS = 3;

export const SECONDARY_MAX_DECIMAL_DIGITS = 2;
